import React from 'react'
import { PREDEFINED_COLORS } from '../../../../../constants'
import InlineSelect from '../InlineSelect/InlineSelect'

const ColorSelect = ({
  onChange,
  value,
  colors = PREDEFINED_COLORS,
  ...restProps
}) => {
  const options = getColorOptions(colors)

  const selectedOption = colors.find(color => color.value === value)

  //Add option "Custom" if input value is missing in provided options
  if (value && !selectedOption) {
    options.push(generateColorOption({ label: 'Custom', value }))
  }

  return (
    <InlineSelect
      label={'Color'}
      value={value}
      options={options}
      onChange={(event, index, value) => onChange(value)}
      cypress_id={restProps.cypress_id}
    />
  )
}

/**
 * Generate color option for select component
 * @param {Object} colorConfig
 * @param {string} colorConfig.label displayed color label
 * @param {string} colorConfig.value Hex color code of the option
 *
 * @returns {Object} colorOption
 * @returns {string} colorOption.label displayed color label
 * @returns {string} colorOption.value Hex color code of the option
 * @returns {Node} colorOption.icon Square, filled with  provided color
 */
const generateColorOption = ({ label, value }) => ({
  label,
  value,
  icon: (
    <div>
      <div
        style={{
          width: '100%',
          height: '100%',
          backgroundColor: value,
          border: '1px solid black',
        }}
      />
    </div>
  ),
})

/**
 * Generate array of options for select component
 * @param {*} colors
 * @param {Object[]} colorConfig
 * @param {string} colorConfig[]label displayed color label
 * @param {string} colorConfig[]value Hex color code of the option
 *
 * @returns {Object[]} colorOption
 * @returns {string} colorOption[].label displayed color label
 * @returns {string} colorOption[].value Hex color code of the option
 * @returns {Node} colorOption[].icon Square, filled with  provided color
 */
const getColorOptions = colors =>
  Array.isArray(colors) ? colors.map(generateColorOption) : []

export default ColorSelect
